import { render, staticRenderFns } from "./CertificateDetailView.vue?vue&type=template&id=ee5d7b36&scoped=true&"
import script from "./CertificateDetailView.vue?vue&type=script&lang=js&"
export * from "./CertificateDetailView.vue?vue&type=script&lang=js&"
import style0 from "./CertificateDetailView.vue?vue&type=style&index=0&id=ee5d7b36&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5d7b36",
  null
  
)

export default component.exports